import Layout from "../../components/Layout";
import AssetSettingModal from "../../components/assetSettingModal/AssetSettingModal";
import Grid from '@material-ui/core/Grid';
import { useEffect } from "react";
import { useAssetSettingModal } from "../../components/assetSettingModal/hooks/useAssetSettingModal";
import { useHistory } from "react-router-dom";
import { TeamType } from "../../components/Type/TeamType";
import { useBattleTeam } from "../../context/battleTeam/useBattleTeam";
import { useAsset } from "../../context/asset/useAsset";
import SettingConfirmArea from "../../components/settingConfirmArea/SettingConfirmArea";

const Top: React.FC = () => {
  let history = useHistory();
  const { attack, defence, updateAttackTeam, updateDefenceTeam } = useBattleTeam()
  const {
    heros,
    extensions,
    artSkilles,
    feacthAssetData,
    filterHeroData,
    filterExtensionData
  } = useAsset()

  const {
    state,
    open,
    close,
    attackTeam,
    defenceTeam,
    nextStateMode,
    backStateMode,
    setExtensionMode,
    updateTeamMemberHeroData,
    updateTeamMemberExtensionData,
    updateTeamMemberArtSkillData,
    onSelectStatePosition,
    onSelectStateModeAndPosition,
    onSelectStateFilterRarity,
    switchingStatePlayer,
    switchingTeam,
    defenceTeamSelect,
    setEffectSkilePositionBottom,
    setEffectSkilePositionTop
  } = useAssetSettingModal({
    initialAttackTeam: attack,
    initialDefenceTeam: defence
  });
  useEffect(() => {
    console.log("!--")
    console.log(attackTeam)
    console.log("^--")
    console.log(defenceTeam)
  }, [attackTeam, defenceTeam]);

  useEffect(() => {
    feacthAssetData()
  }, []);

  const openDefenceTeamAssetSettingModal = () => {
    open({
      mode: "Hero",
      player: "Defence",
      position: "FRONT",
      isAuto: true
    })
  }

  const openAttackTeamAssetSettingModal = () => {
    open({
      mode: "Hero",
      player: "Attack",
      position: "FRONT",
      isAuto: true
    })
  }

  const onBattleResultMoveButtonClick = () => {
    updateAttackTeam(attackTeam)
    updateDefenceTeam(defenceTeam)
    history.push("/playerVersusPlayer/battleResult")
  }
  return (
    <Layout>
      <SettingConfirmArea
        openAttackTeamAssetSettingModal={openAttackTeamAssetSettingModal}
        openDefenceTeamAssetSettingModal={openDefenceTeamAssetSettingModal}
        attackTeam={attackTeam}
        defenceTeam={defenceTeam}
        switchingTeam={switchingTeam}
        onBattleResultMoveButtonClick={onBattleResultMoveButtonClick}
        openTeamAssetSettingModal={open}
        setEffectSkilePositionTop={setEffectSkilePositionTop}
        setEffectSkilePositionBottom={setEffectSkilePositionBottom}
      />
      <AssetSettingModal
        state={state}
        attackTeam={attackTeam}
        defenceTeam={defenceTeam}
        artSkillData={artSkilles}
        nextStateMode={nextStateMode}
        backStateMode={backStateMode}
        setExtensionMode={setExtensionMode}
        updateTeamMemberHeroData={updateTeamMemberHeroData}
        updateTeamMemberExtensionData={updateTeamMemberExtensionData}
        updateTeamMemberArtSkillData={updateTeamMemberArtSkillData}
        onSelectStatePosition={onSelectStatePosition}
        onSelectStateModeAndPosition={onSelectStateModeAndPosition}
        onSelectStateFilterRarity={onSelectStateFilterRarity}
        heros={heros}
        extensions={extensions}
        filterHeroData={filterHeroData}
        filterExtensionData={filterExtensionData}
        close={close}
        switchingStatePlayer={switchingStatePlayer}
        defenceTeamSelect={defenceTeamSelect}
      />
    </Layout >
  );
};

export default Top;
